import { ToastController } from '@ionic/angular';
import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { concat, interval } from 'rxjs';
import { first } from 'rxjs/operators';
import { Constants } from 'app/utility/constants';

@Injectable()
export class CheckForUpdateService
{
    constructor(
        appRef: ApplicationRef,
        updates: SwUpdate,
        private toastController: ToastController)
    {
        if (updates.isEnabled)
        {
            // Allow the app to stabilize first, before starting polling for updates with `interval()`.
            const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
            const everySixHours$ = interval(6 * 60 * 60 * 1000);
            const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);

            everySixHoursOnceAppIsStable$.subscribe(() => updates.checkForUpdate());
            // console.log("Service worker is enabled, so checking for updates every 6 hours");

            updates.versionUpdates.subscribe((event: VersionReadyEvent) =>
            {
                if (event.type === 'VERSION_READY')
                {
                    // localStorage.setItem(Constants.LocalStorage_Updates, "1");
                    // console.log('current version is', event.currentVersion);
                    // console.log('available version is', event.latestVersion);
                    this.presentToastWithOptions();
                }
            });
        }
        else
        {
            // console.log("Service worker not enabled, so not checking for updates");
        }
    }

    async presentToastWithOptions()
    {
        const toast = await this.toastController.create({
            header: 'App update available',
            message: 'A new version of this PWA is available now.',
            buttons: [
                {
                    text: 'Update now',
                    handler: () =>
                    {
                        this.dismissReload(null);
                    }
                },
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () =>
                    {
                        toast.dismiss();
                    }
                }
            ],
            position: 'bottom',
            layout: 'stacked'
        });

        await toast.present();

        toast.onDidDismiss().then(this.dismissReload);
    }

    async dismissReload(dismiss: any)
    {
        if (dismiss.role !== 'cancel')
        {
            // localStorage.setItem(Constants.LocalStorage_Updates, "0");
            window.location.reload();
        }
        else
        {
            // console.log("User chose not to update app");
        }
    }
}
